module.exports = __webpack_public_path__ + "media/dogs/dogAvatar1-8dc0a0af.svg";